import styled from 'styled-components/macro';

export const NoMediaMessage = styled.div`
  font-size: 34px;
  color: #818181;
  margin-top: 50px;
`;

export const NoMediaContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-top: 60px;
`;
